import React, { useState } from 'react'
import IconMinusCircle from '../../../assets/icons/icon-minus-circle.svg'
import {
  AdditionalRequirementsSection,
  AdditionalRequirementsHeader,
  AdditionalRequirementsTitle,
  AdditionalRequirementsIcon,
  AdditionalRequirementsTitleText,
  AdditionalRequirementsCount,
  AdditionalRequirementsBody,
  AdditionalRequirementsDescription,
  AdditionalRequirementCard,
  AdditionalRequirementHeader,
  AdditionalRequirementIcon,
  AdditionalRequirementTitle,
  AdditionalRequirementDescription,
  TextButton
} from './Styles/ProgressTracker.styles'

const AdditionalRequirementsList = ({ additionalRequirements, onLevelClick }) => {
  const [isExpanded, setIsExpanded] = useState(true)

  if (additionalRequirements.length === 0) {
    return null
  }

  return (
    <AdditionalRequirementsSection>
      <AdditionalRequirementsHeader
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <AdditionalRequirementsTitle>
          <AdditionalRequirementsIcon
            style={{
              transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'
            }}
          />
          <AdditionalRequirementsTitleText>
            Additional Requirements
          </AdditionalRequirementsTitleText>
        </AdditionalRequirementsTitle>
        <AdditionalRequirementsCount>
          {additionalRequirements.length}
        </AdditionalRequirementsCount>
      </AdditionalRequirementsHeader>

      {isExpanded && (
        <AdditionalRequirementsBody>
          <AdditionalRequirementsDescription>
            Additional requirements do not need to be completed in a specific level but must be completed before applying for PGA of America Membership.
          </AdditionalRequirementsDescription>

          {additionalRequirements.map((requirement) => (
            <AdditionalRequirementCard key={requirement.id}>
              <AdditionalRequirementHeader>
                <AdditionalRequirementIcon src={IconMinusCircle} alt="" />
                <AdditionalRequirementTitle>
                  Playing Ability Test
                </AdditionalRequirementTitle>
              </AdditionalRequirementHeader>
              <AdditionalRequirementDescription>
                A passing PAT score is needed before applying for PGA of America Membership.{' '}
                <TextButton onClick={() => onLevelClick && onLevelClick('qualifying')}>
                  View Requirement
                </TextButton>
              </AdditionalRequirementDescription>
            </AdditionalRequirementCard>
          ))}
        </AdditionalRequirementsBody>
      )}
    </AdditionalRequirementsSection>
  )
}

export default AdditionalRequirementsList
